import { trans } from '@spotahome/soyuz/client';

export const APARTMENT = 'apartment';
export const STUDIO = 'studio';
export const ROOM_SHARED = 'room_shared';
export const ROOM_SHARED_APT = 'room_shared_apt';
export const RESIDENCE = 'residence';
export const LISTING_TYPES = [
  APARTMENT,
  STUDIO,
  ROOM_SHARED,
  RESIDENCE,
  ROOM_SHARED_APT
];

const TRANSLATION_TYPE_MAPPING = {
  [ROOM_SHARED_APT]: ROOM_SHARED
};

export const getTranslatedPropertyType = type => {
  const mappedType = TRANSLATION_TYPE_MAPPING[type] || type;
  return trans(`homecard.type.${mappedType}.small`);
};

export const isApartment = type => type === APARTMENT;
export const isRoom = type => type === ROOM_SHARED;
